import type { FC } from 'react';
import { Chip, Tooltip, type ChipProps } from '@mui/material';

import type { AuditType } from '#packages/data-collection/models/audit';
import { AuditTypeIcon } from '../audit-type-icon';

export type AuditTypeChipProps = ChipProps & {
  /**
   * The type of the audit.
   */
  type: AuditType;
};

export const AuditTypeChip: FC<AuditTypeChipProps> = ({ type, ...props }) => {
  let label: string;

  switch (type) {
    case 'ea': {
      label = 'Energy Audit';
      break;
    }

    case 'bca': {
      label = 'Building Condition Assessment';
      break;
    }
  }

  return (
    <Tooltip title={label}>
      <Chip
        icon={<AuditTypeIcon type={type} />}
        label={type.toUpperCase()}
        variant="outlined"
        {...props}
      />
    </Tooltip>
  );
};
